document.addEventListener("DOMContentLoaded", (event) => {
  const collectionList = document.querySelectorAll('.catalogue-grid');

  function getFaqSectionIds() {
    return Array.from(document.querySelectorAll('[data-faq-section-id]'))
      .map(el => el.getAttribute('data-faq-section-id'))
      .filter(Boolean);
  }

  collectionList.forEach(function (catalogueGrid) {
    catalogueGrid.addEventListener('click', async function (event) {
      event.preventDefault();

      const target = document.getElementById('yummy_product_grid');
      if (target) {
        const offset = -250;
        const bodyTop = document.body.getBoundingClientRect().top;
        const elementTop = target.getBoundingClientRect().top;
        const elementPosition = elementTop - bodyTop;
        const offsetPosition = elementPosition + offset;

        if (window.innerWidth <= 768) {
          if (window.scrollY > 400) {
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
          }
        } else {
          if (window.scrollY > 800) {
            window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
          }
        }
      }

      if (!this.classList.contains('active')) {
        collectionList.forEach(link => {
          link.classList.remove('active', 'border-[#4C148A]');
          link.classList.add('border-[#FDE1FF]');
        });

        this.classList.remove('border-[#FDE1FF]');
        this.classList.add('active', 'border-[#4C148A]');

        const catalogueUrl = this.getAttribute('data-url');
        history.pushState({}, "", catalogueUrl);

        const mainCollectionGrid = document.querySelector('.yummuy_main_collection__grid');

        if (mainCollectionGrid) {
          const overlay = document.createElement('div');
          overlay.className = 'overlay-new';
          overlay.innerHTML = `<div class="loading-animation-2"></div>`;
          mainCollectionGrid.style.position = 'relative';
          mainCollectionGrid.appendChild(overlay);
        }

        const faqSectionIds = getFaqSectionIds();
        const sectionsParam = ['yummuy_ajax_collection', ...faqSectionIds].join(',');

        try {
          const response = await fetch(`${catalogueUrl}?sections=${sectionsParam}`);
          if (!response.ok) throw new Error('Network response was not ok');

          const data = await response.json();
          const parser = new DOMParser();

          // ===== COLLECTION (UNCHANGED) =====
          const collectionGridDoc = parser.parseFromString(data['yummuy_ajax_collection'], 'text/html');
          const collectionGrid = collectionGridDoc.querySelector('.yummuy_main_collection');

          if (collectionGrid) {
            const mainCollectionGridEl = document.querySelector('.yummuy_main_collection');
            if (mainCollectionGridEl) {
              mainCollectionGridEl.style.opacity = 0;
              mainCollectionGridEl.innerHTML = '';
              mainCollectionGridEl.appendChild(collectionGrid);

              updateCollectionTitle(collectionGrid);
              updateCollectionDescription(collectionGrid);
              loadReviewsIoRatingSnippets();

              const fadeIn = (element, duration) => {
                let opacity = 0;
                const increment = 16 / duration;

                const animate = () => {
                  opacity += increment;
                  if (opacity <= 1) {
                    element.style.opacity = opacity;
                    requestAnimationFrame(animate);
                  } else {
                    element.style.opacity = 1;
                  }
                };

                animate();
              };

              fadeIn(mainCollectionGridEl, 300);
              attachTagClickListener();
            }
          }

          // ===== FAQ FIX START =====

        // Always try to fetch FAQ section even if not on current page
        const faqContainer = document.querySelector('#faq-global-container');

        // fallback section name (IMPORTANT: change if your section file name differs)
        const FALLBACK_FAQ_SECTION = 'yummygums_faq_with_images';

        // Build sections param properly
        const finalSections = faqSectionIds.length
        ? faqSectionIds
        : [FALLBACK_FAQ_SECTION];

        finalSections.forEach(sectionId => {
        const faqHtml = data[sectionId];
        if (!faqHtml) return;

        const faqDoc = parser.parseFromString(faqHtml, 'text/html');

        // Try both (because Shopify sometimes wraps differently)
        const newFaqInner =
            faqDoc.querySelector('.yummuy_faq_ajax_content') ||
            faqDoc.querySelector('[data-faq-section-id]');

        if (!newFaqInner) return;

        // ===== CASE 1: Existing section on page =====
        const sectionRoot = document.querySelector(`[data-faq-section-id="${sectionId}"]`);
        const faqWrapper = sectionRoot?.querySelector('.yummuy_faq_ajax_content');

        if (faqWrapper) {
            faqWrapper.style.transition = 'opacity 0.15s ease';
            faqWrapper.style.opacity = 0;

            setTimeout(() => {
            faqWrapper.innerHTML = newFaqInner.innerHTML;

            faqWrapper.querySelectorAll('custom-accordion').forEach(el => {
                const newEl = el.cloneNode(true);
                el.replaceWith(newEl);
            });

            faqWrapper.style.opacity = 1;
            }, 150);

            return;
        }

        // ===== CASE 2: No section → inject into global container =====
        if (faqContainer) {
            // Parse full HTML (including styles)
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = faqHtml;

            // Extract styles
            const styles = tempDiv.querySelectorAll('style');

            // Remove old dynamic styles (optional but recommended)
            document.querySelectorAll('[data-dynamic-faq-style]').forEach(el => el.remove());

            // Append new styles to <head>
            styles.forEach(style => {
            const newStyle = document.createElement('style');
            newStyle.innerHTML = style.innerHTML;
            newStyle.setAttribute('data-dynamic-faq-style', 'true');
            document.head.appendChild(newStyle);
            });

            // Now inject HTML WITHOUT style tags
            styles.forEach(style => style.remove());

            const cleanContent = tempDiv.querySelector('.yummuy_faq_ajax_content') || tempDiv;

            faqContainer.innerHTML = cleanContent.outerHTML;

            faqContainer.querySelectorAll('custom-accordion').forEach(el => {
            const newEl = el.cloneNode(true);
            el.replaceWith(newEl);
            });
        }
        });
          // ===== FAQ FIX END =====

        } catch (error) {
          console.error('Error fetching collection data:', error);
          if (mainCollectionGrid) {
            mainCollectionGrid.innerHTML = '<div class="error-message">Failed to load content. Please try again.</div>';
          }
        } finally {
          const overlay = document.querySelector('.overlay-new');
          if (overlay) {
            overlay.classList.add('hidden-opacity');
            setTimeout(() => {
              overlay.remove();
            }, 300);
          }
        }
      }
    });
  });

  attachTagClickListener();

  function attachTagClickListener() {
    const tagList = document.querySelectorAll('.collection_tag_list');

    if (tagList.length) {
      tagList.forEach(tag => {
        tag.addEventListener('click', async (event) => {
          event.preventDefault();

          tagList.forEach(link => link.classList.remove('active'));
          tag.classList.add('active');

          const tagUrl = event.currentTarget.getAttribute('data-url');

          try {
            const response = await fetch(`${tagUrl}?sections=yummuy_ajax_collection`);
            if (!response.ok) throw new Error('Network response was not ok');

            const data = await response.json();
            const parser = new DOMParser();
            const doc = parser.parseFromString(data['yummuy_ajax_collection'], 'text/html');
            const collectionGrid = doc.querySelector('.yummuy_main_collection__grid');

            if (collectionGrid) {
              const mainCollectionSection = document.querySelector('.yummuy_main_collection__grid');
              if (mainCollectionSection) {
                mainCollectionSection.innerHTML = collectionGrid.innerHTML;
                loadReviewsIoRatingSnippets();
              }
            }

          } catch (error) {
            console.error('Error fetching data:', error);
          }
        });
      });
    }

    setTimeout(function () {
      $('.ruk-rating-snippet-count b').each(function () {
        var number = parseFloat($(this).html()),
          rounded = number.toFixed(1);
        $(this).html(rounded);
      });
    }, 2000);
  }

  function updateCollectionTitle(fetchedCollection) {
    const mainCollectionGrid = document.querySelector('.yummuy_main_collection');
    if (!mainCollectionGrid) return;

    const textCenter = mainCollectionGrid.querySelector('.collection-main-titles');
    if (!textCenter) return;

    const newTitle1 = fetchedCollection.querySelector('.collection-main-titles .collection-title');
    const currentTitle1 = textCenter.querySelector('.collection-title');

    if (newTitle1 && currentTitle1) {
      currentTitle1.outerHTML = newTitle1.outerHTML;
    } else if (newTitle1 && !currentTitle1) {
      textCenter.insertAdjacentHTML('afterbegin', newTitle1.outerHTML);
    } else if (!newTitle1 && currentTitle1) {
      currentTitle1.remove();
    }
  }

  function updateCollectionDescription(fetchedCollection) {
    const mainCollectionGrid = document.querySelector('.yummuy_main_collection');
    if (!mainCollectionGrid) return;

    const textCenter = mainCollectionGrid.querySelector('.collection-main-description');
    if (!textCenter) return;

    const newDescription = fetchedCollection.querySelector('.collection-main-description .collection-description');
    const currentDescription = textCenter.querySelector('.collection-description');

    if (newDescription && currentDescription) {
      currentDescription.outerHTML = newDescription.outerHTML;
    } else if (newDescription && !currentDescription) {
      textCenter.insertAdjacentHTML('beforeend', newDescription.outerHTML);
    } else if (!newDescription && currentDescription) {
      currentDescription.remove();
    }
  }
});

function loadReviewsIoRatingSnippets() {
  if (typeof ratingSnippet !== 'function') return;

  document.querySelectorAll('.ruk_rating_snippet iframe').forEach(iframe => iframe.remove());

  setTimeout(() => {
    ratingSnippet('ruk_rating_snippet', {
      store: 'yummygumsnl.myshopify.com',
      mode: 'default',
      color: '#FFFFFF',
      linebreak: false,
      text: 'Reviews',
      singularText: 'Review',
      lang: 'en',
      usePolaris: true,
      showEmptyStars: false,
      showNumericalAverageRating: true
    });
  }, 100);
}